import React from "react";

import ThemeToggleButton from "@components-shared/ThemeToggleButton";

export default function HeaderThemeToggle() {
	return <ThemeToggleButton />;
}
